import $ from 'jquery';
import _ from 'underscore';
import * as baseWishlistButtonEvents from '../../tracking/wishlist/baseWishlistButtonEvents';
import * as registry from '../../../home24/core/registry';

export default function WishlistButtonEvents() {

    _.bindAll(this, 'onAddToWishlist', 'onRemoveFromWishlist',
        'onQuickViewOpen', 'onQuickViewLeave', 'onQuickViewArticleChange');

    $.subscribe('added.wishlist', this.onAddToWishlist);
    $.subscribe('removed.wishlist', this.onRemoveFromWishlist);

    // quickview
    $.subscribe('openOverlay.quickView:tracking', this.onQuickViewOpen);
    $.subscribe('leaveOverlay.quickView:tracking', this.onQuickViewLeave);
    $.subscribe('articleChange.quickView:tracking', this.onQuickViewArticleChange);

    this.isQuickViewOpen = false;
    this.quickViewData = {};
    this.extraArticleData = {};
}

WishlistButtonEvents.prototype = _.extend({}, baseWishlistButtonEvents, {

    onAddToWishlist: function (event, eventData) {
        var data = this.getTrackingData(eventData.sku);

        this.pushAddToWishlistEvent(data);
    },

    onRemoveFromWishlist: function (event, eventData) {
        var data = this.getTrackingData(eventData.sku);

        this.pushRemoveFromWishlistEvent(data);
    },

    getTrackingData: function (sku) {
        var data = {};

        if (this.isQuickViewOpen) {
            data = this.getQuickViewTrackingData(sku);
        } else {
            data = this.getListViewTrackingData(sku);
        }

        return data;
    },

    // try to get extra data from listView tracking data
    getArticleDataFromRegistry: function (sku) {

        var data = {};
        var dataSource = registry.get('listView.trackingData');

        // on list-view read from Registry
        if (dataSource && dataSource[sku]) {
            data = dataSource[sku];
        }

        return data;
    },

    getListViewTrackingData: function (sku) {
        var tempData = this.getArticleDataFromRegistry(sku);

        return {
            sku: sku,
            price: tempData.price,
            brand: tempData.brand,
            category: tempData.category
        };
    },

    getQuickViewTrackingData: function (sku) {
        return {
            sku: sku,
            price: this.quickViewData.child.price.trackingPrice.single,
            brand: this.extraArticleData.brand,
            category: this.extraArticleData.category
        };
    },

    onQuickViewOpen: function (event, data) {
        this.isQuickViewOpen = true;
        this.quickViewData = data;

        // try to get extra data, will success if article is on the page
        this.extraArticleData = this.getArticleDataFromRegistry(data.child.sku);
    },

    onQuickViewLeave: function () {
        this.isQuickViewOpen = false;
        this.quickViewData = {};
        this.extraArticleData = {};
    },

    onQuickViewArticleChange: function (event, data) {
        this.quickViewData = data;
    },

    destroy: function () {
        $.unsubscribe('added.wishlist', this.onAddToWishlist);
        $.unsubscribe('removed.wishlist', this.onRemoveFromWishlist);

        // quickview
        $.unsubscribe('openOverlay.quickView:tracking', this.onQuickViewOpen);
        $.unsubscribe('leaveOverlay.quickView:tracking', this.onQuickViewLeave);
        $.unsubscribe('articleChange.quickView:tracking', this.onQuickViewArticleChange);
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/catalog/catalogWishlistButtonEvents.js
 **/